import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbRadioGroup as ClbRadioGroup_ } from '@celebration/design-system/dist/lib/radio-group';
export const ClbRadioGroup = createComponent({
    tagName: ClbRadioGroup_.tagName,
    elementClass: ClbRadioGroup_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map